import {Component} from '@angular/core';


@Component({
    selector: 'db-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: false
})
export class ProductsComponent {
}
